/**
 * The account's plan and usage, for any component that needs to know before it acts.
 *
 * Four different components start AI work and each had its own copy of everything; this is
 * the one place they now agree on what the account is allowed. It subscribes to the shared
 * answer, so a component using it re-renders when a recording is deleted or a plan changes.
 */
import {
  accountSummary,
  currentAccount,
  formatDate,
  subscribeAccount,
} from '@/http/requests/account';

export default {
  data() {
    return { planAccount: currentAccount() };
  },
  computed: {
    /** True only when the server would actually refuse new AI work right now. */
    aiBlocked() {
      return !!(this.planAccount && this.planAccount.aiBlocked);
    },
    recordingBlocked() {
      return !!(this.planAccount && this.planAccount.recordingBlocked);
    },
    /** When the hours come back, always named rather than left vague. */
    aiResetLabel() {
      const end = this.planAccount && this.planAccount.periodEnd;
      return end ? formatDate(end) : '';
    },
    /** Why a session is about to run unrecorded, in the numbers the person can check. */
    recordingBlockedMessage() {
      const acc = this.planAccount;
      if (!acc) return '';
      const used = acc.storage && acc.storage.usedLabel;
      const allowed = acc.storage && acc.storage.allowedLabel;
      const where =
        used && allowed ? ` Your account holds ${used} of ${allowed}.` : '';
      return (
        `Storage is full, so this session will not be recorded.${where} ` +
        'The session itself is unaffected: delete a recording or change plan to record again.'
      );
    },
    aiBlockedMessage() {
      const acc = this.planAccount;
      if (!acc) return '';
      const when = this.aiResetLabel;
      return when
        ? `The AI hours on your plan are spent. They reset ${when}.`
        : 'The AI hours on your plan are spent for this period.';
    },
  },
  created() {
    this.__planUnsubscribe = subscribeAccount((acc) => {
      this.planAccount = acc;
    });
    accountSummary().catch(() => {});
  },
  beforeDestroy() {
    if (this.__planUnsubscribe) this.__planUnsubscribe();
  },
};
